export const ProductsEndpoints = {
  getProductsPaywall: (membershipSlug: string, communityId: number) =>
    `/rest/v1/memberships/${membershipSlug}/products/community/${communityId}/sale`,
  getProductsPaywallPublic: (membershipSlug: string, communityId: number) =>
    `/rest/public/v2/memberships/${membershipSlug}/products/community/${communityId}/sale`,
  getSaleProducts: (membershipSlug: string) => `/rest/public/v1/products/${membershipSlug}/sale`,
  getPurchasedProducts: (membershipSlug: string) => `/rest/v3/products/${membershipSlug}/purchased`,
  getMyProductsProgress: (ucode?: string) => `/rest/v1/users/${ucode}/profile/products`
}
